import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { deepDeleteAll } from 'labguard-cdk'

/**
 * Improve InMemoryCache prototype with a function invalidating a fragment from the cache
 */
InMemoryCache.prototype.invalidate = function(fragment) {
  // get fragment id
  const id = this.config.dataIdFromObject(fragment)

  // delete fragment from cache (and trigger UI refresh)
  this.data.delete(id)
}

/**
 * Improve InMemoryCache prototype with a function deleting a fragment and all its references in cache.
 */
InMemoryCache.prototype.deleteFragment = function(fragment) {
  // get fragment id
  const id = this.config.dataIdFromObject(fragment)

  // delete all fragment references from cache
  deepDeleteAll(this.data.data, fragment => fragment && fragment.type === 'id' && fragment.id === id)

  // delete fragment from cache (and trigger UI refresh)
  this.data.delete(id)
}

/**
 * Improvie InMemoryCache prototype with a function clearing the entire cache
 */
InMemoryCache.prototype.clear = function() {
  this.data.replace()
}

export default new InMemoryCache({
  dataIdFromObject: function(object) {
    switch (object.__typename) {
      // generate unique ID for system settings
      case 'SystemSettings':
        return 'SystemSettings'
      default:
        return defaultDataIdFromObject(object)
    }
  },
})
